var render = function render(){var _vm=this,_c=_vm._self._c;return _c('date-range-picker',{attrs:{"start-date":_vm.dateRange.start,"end-date":_vm.dateRange.end,"dusk":"looker-date-range-picker"},on:{"update":_vm.updateDate}})
}
var staticRenderFns = []

export { render, staticRenderFns }